import { ThemeContext } from "@/contexts/theme/theme.context";
import { useContext } from "react";

/**
 * Hook to access theme context.
 * @returns Theme context with theme state, setTheme function, and resolvedTheme
 */
export default function useTheme() {
  return useContext(ThemeContext);
}

